/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ReportOptionDto
 */
export interface ReportOptionDto {
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportOptionDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportOptionDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    $type?: ReportOptionDtoTypeEnum;
}


/**
 * @export
 */
export const ReportOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedReportComponentDtoReportOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.ReportComponent.Dto.ReportOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ReportOptionDtoTypeEnum = typeof ReportOptionDtoTypeEnum[keyof typeof ReportOptionDtoTypeEnum];


/**
 * Check if a given object implements the ReportOptionDto interface.
 */
export function instanceOfReportOptionDto(value?: unknown): value is ReportOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ReportOptionDtoTypeEnum)[0];
}

export function ReportOptionDtoFromJSON(json: any): ReportOptionDto {
    return ReportOptionDtoFromJSONTyped(json, false);
}

export function ReportOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportOptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ReportOptionDtoToJSON(value?: ReportOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'address': value.address,
        'imageId': value.imageId,
        '$type': value.$type,
    });
}

